import React from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import { makeStyles } from "@material-ui/core/styles";
import { Divider } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { ROUTE_LOGIN } from "../routes/routesConstants";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/authentication/selectors";

const useStyles = makeStyles(() => ({
  divider: {
    // backgroundColor: "#fff",
    // opacity: ".5",
    marginTop: '.5rem'
  },
}));

const linkData = [
  {
    url: "https://www.bosch.com/",
    text: "Perfil",
  },
  {
    url: "https://www.bosch.com/",
    text: "Configurações",
  },
  {
    url: "https://www.bosch.com/",
    text: "Sair",
  },
  // {
  //   url: "https://cita-online-taller.bmw.es/es/index",
  //   text: "OAS"
  // },
  // {
  //   url: "https://es.repair.groupautointernational.com/",
  //   text: "Eurotaller"
  // },
  // {
  //   url: "https://autorizaciones.alphabet.es/",
  //   text: "AOL"
  // },
  // {
  //   url: "https://rental.alphabet.es/Reservas",
  //   text: "Alphabet"
  // },
  // {
  //   url: "https://www.resacar.com",
  //   text: "Hertz"
  // },
  // {
  //   url: "https://production.rent-at-avis.com/avisonline/es/ibe.nsf/reservationhomemicrosite?openview&MST=8A1AE4A34034D95AC1257A290021BA8B",
  //   text: "Avis"
  // },
  // {
  //   url: "https://www.europcar.biz/chbse/showLogin.do;jsessionid=qktzEgemzH16BMWRwhj6owlX.PRODECUL0234:JP_UKPR_04",
  //   text: "Europcar"
  // },
  // {
  //   url: "https://www.armsweb.es/aw-global/auth",
  //   text: "Enterprise"
  // }
];

function ProfileMenu(props) {
  const { anchor, open, handleClose } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const user = useSelector(selectUser);

  function handleProfile(){
    handleClose(false);
    props.setShowProfileDialog(true);
  }

  function handleLogout(){
    handleClose(false);
    localStorage.removeItem('apoloCRM_Token');
    history.push(ROUTE_LOGIN);
  }

  return (
    <Popper
      id="popper"
      open={open}
      style={{ width: "9rem" }}
      anchorEl={anchor.current}
      role={undefined}
      transition
      disablePortal
      placement={"bottom-start"}
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps} style={{ transformOrigin: "left top" }}>
          <Paper square elevation={0}>
            <span style={{padding: "6px 16px", color: '#656464'}}>{user?.user?.userName}</span>
            <Divider classes={{root: classes.divider}}/>
            <ClickAwayListener onClickAway={() => handleClose(false)}>
              <MenuList
                autoFocusItem={open}
                id="menu-list-grow"
                classes={{ root: classes.list }}
              >
                {/* {linkData.map((e, i, a)=>
                    [<MenuItem key={e.text} ListItemClasses={{button: classes.button}} component="a" href={e.url} target="_blank" classes={{root: classes.listItem}} >
                        {e.text}
                        </MenuItem>,
                    i < a.length-1 && <Divider key={"divider-"+i} classes={{root: classes.divider}}  component="li" />
                    ]    
                    )} */}
                <MenuItem
                  key={"profile-menu-item-2"}
                  ListItemClasses={{ button: classes.button }}
                  component="a"
                  //href={e.url}
                  target="_blank"
                  classes={{ root: classes.listItem }}
                  onClick={() => handleProfile()}
                >
                  {t("Profile")}
                </MenuItem>
                <MenuItem
                  key={"profile-menu-item-3"}
                  ListItemClasses={{ button: classes.button }}
                  component="a"
                  //href={e.url}
                  target="_blank"
                  classes={{ root: classes.listItem }}
                  onClick={handleLogout}
                >
                  {t("Logout")}
                </MenuItem>
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
}

export { ProfileMenu };
